// src/context/AuthContext.tsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getJWtDetails } from '../utils/AppUtils';
import { IUserProfile } from '../redux/user/actions';

interface AuthContextType {
    isSignedIn: boolean;
    refreshAuth: () => void; // Optional if you want to manually refresh
    user?: IUserProfile | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isSignedIn, setIsSignedIn] = useState(getJWtDetails().isSignedIn);

    const refreshAuth = () => {
        const { isSignedIn: newStatus } = getJWtDetails();
        setIsSignedIn(newStatus);
    };

    // Optional: Automatically refresh on interval or auth event
    useEffect(() => {
        const interval = setInterval(refreshAuth, 3000); // Poll every 3s, or use a custom event
        return () => clearInterval(interval);
    }, []);

    return (
        <AuthContext.Provider value={{ isSignedIn, refreshAuth, user: getJWtDetails().user }}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook to use auth
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within AuthProvider');
    return context;
};
